import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer token from localStorage as a fallback for cross-origin
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("weave_token");
  if (token && !cfg.headers.Authorization) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

// On 401 from a non-auth endpoint, the session has expired — bounce to /login.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    const isAuthCall = url.includes("/auth/");
    if (status === 401 && !isAuthCall && typeof window !== "undefined") {
      try {
        localStorage.removeItem("weave_token");
        const path = window.location.pathname + window.location.search;
        const target = `/login?expired=1${path && path !== "/login" ? `&next=${encodeURIComponent(path)}` : ""}`;
        if (!window.location.pathname.startsWith("/login")) {
          window.location.replace(target);
        }
      } catch {}
    }
    return Promise.reject(err);
  }
);

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
